import React, {useEffect, useState} from 'react';
import {Modal, ProgressBar} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import {connect} from "react-redux";
import ValidationError from "~/Components/Forms/ValidationError";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminTextEdit = ({event, name, children, onChange, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const text = event.texts.find(t => t.name === name)

    const [form, setForm] = useState({
        name: name,
        text: text?.text || '',
        translations: text?.translations || {}
    });

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        setForm(formData);
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {

        adminHttp
            .put('/events/' + event.id + '/text', form)
            .then(res => {
                setShow(false);
                onChange();
            }).catch((error) => {
            setError(error.response?.data);
        });
    };

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Text</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">

                                <Translated
                                            enabled={!!text?.id}
                                            translations={form.translations}
                                            onChanged={(values) => setForm({...form, translations: values})}>
                                    <textarea
                                        rows={10}
                                        name="text"
                                        className="form-control"
                                        value={form.text}
                                        onChange={handleChange}/>
                                </Translated>

                                <ValidationError errors={error?.errors} name="text"/>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleSubmit} className="btn btn-primary btn-sm d-inline">Save</button>
                    <button onClick={handleClose} className="btn btn-secondary btn-sm d-inline">Cancel</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminTextEdit);
